import type { OrderNode } from '../graphql/queries/orders';

/**
 * React-computed invoice numbers (INV00001, …). Not persisted in WooCommerce.
 * Replace with order meta (e.g. _ngk_invoice_number) when available on the backend.
 */
export function formatInvoiceNumber(sequence: number): string {
  return `INV${String(sequence).padStart(5, '0')}`;
}

export function buildInvoiceNumberMap(orders: OrderNode[]): Map<number, string> {
  const sorted = [...orders].sort((a, b) => {
    const dateA = a.date ? new Date(a.date).getTime() : 0;
    const dateB = b.date ? new Date(b.date).getTime() : 0;
    if (dateA !== dateB) return dateA - dateB;
    return (a.databaseId ?? 0) - (b.databaseId ?? 0);
  });

  const map = new Map<number, string>();
  sorted.forEach((order, index) => {
    map.set(order.databaseId, formatInvoiceNumber(index + 1));
  });
  return map;
}
